var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-locked"},[_c('div',{staticClass:"icon"},[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.hint)?_c('small',[_vm._v(_vm._s(_vm.hint))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c3e07e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/ModuleLocked.vue
// module id = ryyt
// module chunks = 1